module.exports = __webpack_public_path__ + "static/img/sb02.4b70bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/sb02.png
// module id = oYPq
// module chunks = 1